export default __webpack_public_path__ + "static/media/md.ef395b51.svg";